import React, { FC } from 'react';

import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { APIS } from '../../../../lib/constants/apis';
import { PLATZHALTER_TEXT } from '../../../../lib/constants/constant';
import Schema from '../../../../lib/paths/unternehmen_FULL_Paths.json'
import ApplicationHeading from '../../../../pages/private/online-antrag/application-heading/ApplicationHeading';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';
import MUIAlert from '../../../ui-component/mui-alert/MUIAlert';
const P = Schema.attributes;

const OrganisationDaten: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	organisationDatenError: any;
	formErrorMessage: string;
}> = ({ formValue, updateFunction, organisationDatenError, formErrorMessage }) => {
	return (
		<>
			<ApplicationHeading title="Angaben zur Organisation" description={PLATZHALTER_TEXT} />
			{formErrorMessage && (
				<MUIAlert
					infoType="error"
					message="Ihr Organisation ist bereit registriert. Fragen Sie Ihren Nutzerverwalter für die Freischaltung des Account"
				/>
			)}
			{/* <Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucUstd()}
						updateFormValuesFunc={updateFunction}
						formErrors={organisationDatenError}
						api={APIS.Organisation}
					/>
				</Grid2>
			</Grid2> */}

			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucSpalte1()}
						updateFormValuesFunc={updateFunction}
						formErrors={organisationDatenError}
						api={APIS.Organisation}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucSpalte2()}
						updateFormValuesFunc={updateFunction}
						formErrors={organisationDatenError}
						api={APIS.Organisation}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default OrganisationDaten;

// const formStrucUstd = () => {
// 	return [
// 		{
// 			fields: [P.Unternehmensprofil_U_St_Id_Nr],
// 			userProps: { columnToDivide: 1 },
// 		},
// 	];
// };

const formStrucSpalte1 = () => {
	return [
		{
			fields: [
				P.Geschaeftsbezogene_Daten_Name_Der_Organisation,
				// P.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [P.Adressdaten_PLZ, P.Adressdaten_Ort],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Adressdaten_Strasse_Und_Hausnummer, P.Adressdaten_Adresszusatz],
			userProps: { columnToDivide: 2 },
		},
		// {
		// 	fields: [P.Adressdaten_Region, P.Adressdaten_Land],
		// 	userProps: { columnToDivide: 2 },
		// },
		{
			fields: [P.Kontaktdaten_Webadresse],
			userProps: { columnToDivide: 1 },
		},
		// {
		// 	fields: [P.Geschaeftsbezogene_Daten_Rolle],
		// 	userProps: { columnToDivide: 1 },
		// },
	];
};

const formStrucSpalte2 = () => {
	return [
		{
			fields: [
				P.Geschaeftsbezogene_Daten_Kurzbeschreibung_Der_Organisation,
				// P.Geschaeftsbezogene_Daten_Kuerzel,
				// P.Geschaeftsbezogene_Daten_Institutionstyp,
				P.Kontaktdaten_E_Mail,
				P.Kontaktdaten_Telefon,
				P.Kontaktdaten_Fax,

			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};
